import '../../app.es6';
import angular from 'angular';

class CoachSignInController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonAuthFactory, commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$location = $location;
    this.commonAuthFactory = commonAuthFactory;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = 'small-height';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
    this.isFailed = false;
    this.isLimit = false;
    Page.setTitle(this.Const.TITLE.signInForStaff);
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    let sessionRole = this.$sessionStorage[this.Const.LSAPP_ROLE];
    let role = localStorage.getItem(this.Const.LSAPP_ROLE);
    // Cognito Credentials
    let userId = localStorage.getItem(this.Const.LSKEY_USER_ID);
    let jwtToken = localStorage.getItem(this.Const.LSKEY_USER_ID_TOKEN);
    let accessKeyId = localStorage.getItem(this.Const.LSKEY_USER_ACCESS_KEY_ID);
    let secretAccessKey = localStorage.getItem(this.Const.LSKEY_USER_SECRET_ACCESS_KEY);
    let sessionToken = localStorage.getItem(this.Const.LSKEY_USER_SESSION_TOKEN);
    let refreshToken = localStorage.getItem(this.Const.LSKEY_USER_REFRESH_TOKEN);
    let accessToken = localStorage.getItem(this.Const.LSKEY_USER_ACCESS_TOKEN);
    let isCredential = false;
    if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
      isCredential = true;
    }
    if ((!sessionRole && role && isCredential) && role !== this.Const.LSAPP_ROLE_MEMBER) {
      this.simplicitySignIn();
    }
    document.getElementById('user_id').focus();

    CoachSignInController.$inject = [
      '$scope', '$sessionStorage', '$location',
      'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  signIn () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.isFailed = false;
    this.isLimit = false;

    let id = this.userId;
    let password = this.userPass;
    let userAuth = this.commonAuthFactory.staffLogin(id, password, null);
    this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_STAFF);
    userAuth.then((userCredentials) => {
      return this.commonAuthFactory.getCredentialsForAPI(
        userCredentials, localStorage.getItem(this.Const.LSAPP_ROLE)
      );
    })
    .then(() => {
      return this.commonApiFactory.getStaffsMe();
    })
    .then((staff) => {
      switch (staff.role.name) {
        case this.Const.LSAPP_ROLE_C_ADMIN: // Company Admin
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_C_ADMIN);
          this.$sessionStorage[this.Const.SSAPP_COMPANY_ID] = staff.companyId;
          this.$location.path('/admin/school');
          break;
        case this.Const.LSAPP_ROLE_S_ADMIN: // School Admin
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_S_ADMIN);
          this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
          this.$location.path('/admin');
          break;
        default: // coach,reception
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_STAFF);
          this.$sessionStorage[this.Const.SSAPP_COACH_NAME] = staff.name;
          this.$sessionStorage[this.Const.SSAPP_COACH_GENDER] = staff.gender !== null ? staff.gender : 0;
          let schoolIds = [];
          return this.commonApiFactory.getStaffsMeCourses()
          .then((courses) => {
            courses.forEach((v) => {
              schoolIds.push(v.schoolId);
            });
            schoolIds = Array.from(new Set(schoolIds));
            if (schoolIds.length === 0) {
              this.$location.path('/staff');
            } else if (schoolIds.length === 1) {
              this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = courses[0].schoolId;
              this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = courses[0].schoolName;
              this.$location.path('/staff');
            } else {
              // コーチに紐づくスクールが複数存在する場合はスクール一覧でスクールを選択する
              this.$location.path('/staff/school_list');
            }
          });
      }
    })
    .then(() => {
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      if (error) {
        if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
          this.isFailed = false;
          this.isLimit = true;
        } else {
          this.isFailed = true;
          this.isLimit = false;
        }
      } else {
        this.isFailed = true;
        this.isLimit = false;
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  simplicitySignIn () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.isFailed = false;
    this.isLimit = false;

    this.commonApiFactory.getStaffsMe()
    .then((staff) => {
      switch (staff.role.name) {
        case this.Const.LSAPP_ROLE_C_ADMIN: // Company Admin
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_C_ADMIN);
          this.$sessionStorage[this.Const.SSAPP_COMPANY_ID] = staff.companyId;
          this.$location.path('/admin/school');
          break;
        case this.Const.LSAPP_ROLE_S_ADMIN: // School Admin
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_S_ADMIN);
          this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
          this.$location.path('/admin');
          break;
        default: // coach,reception
          this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_STAFF);
          this.$sessionStorage[this.Const.SSAPP_COACH_NAME] = staff.name;
          this.$sessionStorage[this.Const.SSAPP_COACH_GENDER] = staff.gender !== null ? staff.gender : 0;
          let schoolIds = [];
          return this.commonApiFactory.getStaffsMeCourses()
          .then((courses) => {
            courses.forEach((v) => {
              schoolIds.push(v.schoolId);
            });
            schoolIds = Array.from(new Set(schoolIds));
            if (schoolIds.length === 0) {
              this.$location.path('/staff');
            } else if (schoolIds.length === 1) {
              this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = courses[0].schoolId;
              this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = courses[0].schoolName;
              this.$location.path('/staff');
            } else {
              // コーチに紐づくスクールが複数存在する場合はスクール一覧でスクールを選択する
              this.$location.path('/staff/school_list');
            }
          });
      }
    })
    .then(() => {
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      if (error) {
        if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
          this.isFailed = false;
          this.isLimit = true;
        } else {
          this.isFailed = true;
          this.isLimit = false;
        }
      } else {
        this.isFailed = true;
        this.isLimit = false;
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }
}

angular.module('myApp').controller('CoachSignInController', CoachSignInController);



// WEBPACK FOOTER //
// ./app/components/coach-sign-in/coach-sign-in-controller.es6